/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Label_Local_Print_Open_FailedInputs */

const vi_lot_label_local_print_open_failed = /** @type {(inputs: Lot_Label_Local_Print_Open_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không mở được cửa sổ in`)
};

/**

* @param {Lot_Label_Local_Print_Open_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_label_local_print_open_failed = /** @type {((inputs?: Lot_Label_Local_Print_Open_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Label_Local_Print_Open_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_label_local_print_open_failed(inputs)
});